//----------------------------------------------------------------------------------------------------------------------
// Occluder Property Handler
//----------------------------------------------------------------------------------------------------------------------

import { Mesh } from '@babylonjs/core';

import type { LevelManager } from '../managers/level.ts';

//----------------------------------------------------------------------------------------------------------------------

/**
 * Register the occluder property handler.
 *
 * Supports the following property on scene nodes:
 * - `occluder` (boolean): If true, marks the mesh as an occluder for occlusion culling
 *
 * Occluder meshes are used by the engine to hide objects that are behind them,
 * improving rendering performance. The occluder mesh itself is made invisible.
 *
 * @param levelManager
 */
export function registerOccluderHandler(levelManager : LevelManager) : void
{
    levelManager.registerPropertyHandler('occluder', (node, value, _level, _gameEngine) =>
    {
        if(!value)
        {
            return;
        }

        // Only meshes can be occluders
        if(!(node instanceof Mesh))
        {
            return;
        }

        // Mark as occluder and hide
        // Note: isOccluder exists at runtime but is missing from @babylonjs/core type definitions as of 9.0
        (node as Mesh & { isOccluder : boolean }).isOccluder = true;
        node.isVisible = false;
    });
}

//----------------------------------------------------------------------------------------------------------------------
